import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ComputerIcon from "@mui/icons-material/Computer";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import HomeIcon from "@mui/icons-material/Home";
export function AppointmentSummaryCard({ isMobile = false, timeDisplay, totalDue, currencySymbol, originalPrice, isFreeBooking, selectedPackLabel, selectedActiveSessionPack, showFee = true, feePending = false, consultationMode = "OFFLINE", label, showModeChips = true, t, }) {
    let feeLabel;
    if (selectedActiveSessionPack || isFreeBooking) {
        feeLabel = t("free", "Free");
    }
    else if (totalDue === null) {
        feeLabel = timeDisplay ? t("priceUnavailable", "Price unavailable") : "—";
    }
    else {
        feeLabel = `${currencySymbol}${totalDue.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    }
    return (_jsx(Box, { sx: {
            bgcolor: "rgba(21, 59, 98, 0.04)",
            border: 1,
            borderColor: "divider",
            borderRadius: 1.5,
            px: isMobile ? 1.5 : 2,
            py: isMobile ? 1.25 : 1.5,
        }, children: _jsxs(Stack, { direction: isMobile ? "column" : "row", alignItems: isMobile ? "flex-start" : "center", justifyContent: "space-between", spacing: isMobile ? 1 : 1.5, sx: { width: "100%" }, children: [_jsxs(Stack, { direction: "row", alignItems: isMobile ? "flex-start" : "center", spacing: 1.5, sx: { minWidth: 0, flex: 1 }, children: [_jsx(Box, { sx: {
                                width: isMobile ? 44 : 56,
                                height: isMobile ? 44 : 56,
                                borderRadius: 1.75,
                                bgcolor: "rgba(203, 163, 76, 0.18)",
                                color: "#cba34c",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }, children: _jsx(EventAvailableOutlinedIcon, { sx: { fontSize: isMobile ? 22 : 28 } }) }), _jsxs(Box, { sx: { minWidth: 0 }, children: [_jsx(Typography, { variant: "overline", color: "text.secondary", sx: { display: "block", lineHeight: 1.1 }, children: label ?? t("selectedAppointment", "Selected Appointment") }), _jsx(Typography, { sx: {
                                        fontWeight: 700,
                                        mt: 0.25,
                                        fontSize: isMobile ? 15 : 17,
                                        lineHeight: 1.25,
                                        color: timeDisplay ? "text.primary" : "text.disabled",
                                        ...(isMobile
                                            ? { wordBreak: "break-word" }
                                            : {
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }),
                                    }, children: timeDisplay
                                        ? timeDisplay.dateStr
                                        : t("chooseDateAndSlot", "Choose a date and slot") }), timeDisplay && showModeChips && (_jsxs(Box, { sx: {
                                        mt: 0.75,
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 0.75,
                                    }, children: [_jsx(Chip, { icon: consultationMode === "ONLINE" ? (_jsx(ComputerIcon, { sx: { fontSize: "12px !important" } })) : (_jsx(HomeIcon, { sx: { fontSize: "12px !important" } })), label: timeDisplay.mode, size: "small", variant: "outlined", sx: { fontSize: 11, height: 22 } }), timeDisplay.duration && (_jsx(Chip, { icon: _jsx(AccessTimeIcon, { sx: { fontSize: "12px !important" } }), label: timeDisplay.duration, size: "small", variant: "outlined", sx: { fontSize: 11, height: 22 } }))] }))] })] }), showFee && (_jsxs(Box, { "aria-busy": feePending || undefined, sx: {
                        textAlign: isMobile ? "left" : "right",
                        flexShrink: 0,
                        pl: isMobile ? 7 : 0,
                    }, children: [_jsx(Typography, { variant: "overline", color: "text.secondary", sx: { display: "block", lineHeight: 1.1, mb: 0.25 }, children: t("consultationFee", "Consultation Fee") }), feePending ? (_jsx(Skeleton, { variant: "text", width: 88, sx: {
                                fontSize: isMobile ? 15 : 17,
                                lineHeight: 1.1,
                                ml: isMobile ? 0 : "auto",
                            } })) : (_jsxs(_Fragment, { children: [_jsx(Typography, { sx: {
                                        fontWeight: 700,
                                        lineHeight: 1.1,
                                        fontSize: isMobile ? 15 : 17,
                                        color: "primary.main",
                                    }, children: feeLabel }), originalPrice &&
                                    !isFreeBooking &&
                                    !selectedActiveSessionPack && (_jsxs(Typography, { variant: "caption", sx: {
                                        color: "text.disabled",
                                        textDecoration: "line-through",
                                        display: "block",
                                    }, children: [currencySymbol, originalPrice.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })] })), selectedPackLabel && !selectedActiveSessionPack && (_jsx(Typography, { variant: "caption", color: "text.secondary", children: selectedPackLabel })), selectedActiveSessionPack && (_jsx(Typography, { variant: "caption", color: "success.main", sx: { fontWeight: 600 }, children: t("coveredBySessionPack", "Covered by session pack") }))] }))] }))] }) }));
}
